import { Component, Input, OnInit } from '@angular/core';

import { EmpowerModernLifeService } from 'src/services/empower-services/empower-modern-life.service';
import { EmpowerExportService } from 'src/services/empower-services/empower-export.service';
import { generateTitleDiv, NO_IMAGE, undefinedImagePath } from 'src/modules/empower-module/helper';

@Component({
  selector: 'empower-grow-in-gaming-windows-market-opportunity',
  templateUrl: './empower-grow-in-gaming-windows-market-opportunity.component.html',
  styleUrls: ['./empower-grow-in-gaming-windows-market-opportunity.component.scss']
})
export class EmpowerGrowInGamingWindowsMarketOpportunityComponent implements OnInit {

  @Input() data: any;
  // ../assets/empower/pitch-factory/images/12-screen-01.png
  imageUrl = NO_IMAGE;
  innerHtml = '';

  constructor(public empowerModernLifeService: EmpowerModernLifeService, private empowerExportService: EmpowerExportService) { }

  ngOnInit(): void {
    if (this.data) {
      this.data = JSON.parse(this.data);
      this.checkPageState(this.data.pageId);
    }
  }

  emitExportEvent(resolvedState: boolean) {
    setTimeout(() => {
      this.data && this.data.export && this.empowerExportService.setExportComponentSubject(12, resolvedState, this.data.pageIndex, this.data.pageTitle);
    }, 1000);
  }

  checkPageState(pageId) {
    const imageUrl = this.empowerModernLifeService.getPageImgState(pageId);
    if (imageUrl) {
      this.imageUrl = imageUrl;
    }
    if (this.imageUrl == NO_IMAGE) this.emitExportEvent(null);

    this.innerHtml = generateTitleDiv(this.data);
  }

  imageChange(imageUrl) {
    this.empowerModernLifeService.setPageImgState(this.data.pageId, imageUrl);
  }

}
